import { where } from "firebase/firestore";
import {
  ModuleModel,
  ModuleStatusEnum,
} from "../../data/models/modules/ModuleModel";
import { useLoading } from "../../data/providers/LoadingProvider";
import { useSnackbar } from "../../data/providers/SnackbarProvider";
import { useUserData } from "../../data/providers/UserDataProvider";
import { useFirestoreActions } from "./useFirestoreActions";
import { useFirestoreListener } from "./useFirestoreListener";

export const useModules = () => {
  const userData = useUserData()!;
  const { showSnackbar, showError } = useSnackbar();
  const { startLoading, stopLoading, loading } = useLoading();
  const { createCollectionWithId } = useFirestoreActions();

  const { data: modules, unsubscribe } = useFirestoreListener<ModuleModel>(
    "modules",
    {
      mapFn: (doc: ModuleModel) => new ModuleModel(doc),
      enabled: true,
      constraints: [
        where("companyCode", "==", userData.data.currentCompany.companyCode),
        where("storeCode", "==", userData.data.currentStore.storeCode),
      ],
    }
  );

  const createModule = async (data: Omit<ModuleModel, "id">) => {
    try {
      startLoading();
      const payload: ModuleModel = {
        ...data,
        status: data.status ?? ModuleStatusEnum.CLOSING,
        userName: "",
        orderId: "",
        companyCode: userData.data.currentCompany.companyCode,
        storeCode: userData.data.currentStore.storeCode,
        createdAt: new Date(),
        updatedAt: new Date(),
      };
      await createCollectionWithId("modules", payload);
      showSnackbar("Módulo creado exitosamente");
    } catch (err) {
      console.error(err);
      showError("No se pudo crear el módulo");
    } finally {
      stopLoading();
    }
  };

  const deleteModule = async (id: string) => {
    // try {
    //   startLoading();
    //   // TODO: aca hacer peticion al back para que elimine y chequee si tiene ordenes
    //   showSnackbar("Módulo eliminado");
    // } catch (err) {
    //   showError("No se pudo eliminar el módulo");
    // } finally {
    //   await subscribeToModules(true);
    //   stopLoading();
    // }
  };

  return {
    modules,
    createModule,
    deleteModule,
    loading,
  };
};
